import Vue from "vue";
import Component from "vue-class-component";
import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import { AppointmentInterface } from "@/api/Interfaces/AppointmentInterface";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";
import { mapGetters } from "vuex";
import AlertMessage from "@/components/Util/AlertMessage/AlertMessage.vue";

const ValidatePatientProps = Vue.extend({
  components: {
    AlertMessage,
  },
  props: {
    serviceAppoint: Object as () => AppointmentInterface,
    patient: Object,
    loading: Boolean,
  },
  computed: mapGetters(["getCpf", "getPatientData"]),
});
@Component<ValidatePatient>({
  name: "ValidatePatient",

  watch: {
    cx_patientDocument: function (newValue) {
      this.$store.commit("setPatient", "");

      if (newValue.length === 14) {
        if (this.cpfIsValid(newValue)) {
          if (newValue !== this.getCpf) {
            this.$emit("removeOldPatientData");
          }
          this.errorMessage = "";
          this.isDocumentValid(newValue);
        } else {
          this.errorMessage = "CPF inválido. Informe um número válido para continuar.";
          this.$emit("isDocumentValid", false);
        }
      } else {
        this.errorMessage = "";
        this.$emit("isDocumentValid", false);
      }
    },
  },
})
export default class ValidatePatient extends ValidatePatientProps {
  cx_serviceAppoint = this.serviceAppoint;
  cx_patient = this.patient;
  cx_patientDocument = "";
  errorMessage = "";
  getPatientData!: any;

  constructor() {
    super();
    this.cx_serviceAppoint = this.serviceAppoint;
  }

  mounted() {
    GoogleAnalyticsEvents.loadUserIdentification();
    this.cx_patientDocument = this.getCpf;
  }

  isDocumentValid = (document: string): void => {
    this.cx_patientDocument = document;
    this.$emit("isDocumentValid", true, document);
  };

  cpfIsValid = (doc: string): boolean => {
    const document = doc.replace(/\D/g, "");
    let documentValid = false;

    if (document.length === 11) {
      const cpf = document.split("");

      let v1 = 0;
      let v2 = 0;
      let aux = false;

      for (let i = 1; cpf.length > i; i++) {
        if (cpf[i - 1] != cpf[i]) {
          aux = true;
        }
      }

      if (aux == false) {
        documentValid = false;
      }

      for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
        v1 += parseInt(cpf[i]) * p;
      }

      v1 = (v1 * 10) % 11;

      if (v1 == 10) {
        v1 = 0;
      }

      if (v1 != parseInt(cpf[9])) {
        documentValid = false;
      }

      for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
        v2 += parseInt(cpf[i]) * p;
      }

      v2 = (v2 * 10) % 11;

      if (v2 == 10) {
        v2 = 0;
      }

      if (v2 != parseInt(cpf[10])) {
        documentValid = false;
      } else {
        documentValid = true;
      }

      if (
        document == "00000000000" ||
        document == "11111111111" ||
        document == "22222222222" ||
        document == "33333333333" ||
        document == "44444444444" ||
        document == "55555555555" ||
        document == "66666666666" ||
        document == "77777777777" ||
        document == "88888888888" ||
        document == "99999999999"
      ) {
        documentValid = false;
      }
    }

    return documentValid;
  };
}
